import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26f0963e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-item" }

import { isAndrod } from '@/utils/app'
import { Uploader, Image, ImagePreview } from 'vant'
import { useUploadImage } from '@/compositions/useUpload'
import type { CommonUploaderFileListItem } from '@/types/public'
import { useUserPermissionVerify } from '@/compositions/useUserAuthPermission'
import {
  Ref,
  ref,
  withDefaults,
  nextTick,
  computed,
} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadImage',
  props: {
    defaultList: { default: () => [] },
    maxCount: { default: 'Infinity' },
    useCrmUpload: { type: Boolean, default: false },
    capture: null,
    disabled: { type: Boolean, default: false },
    cameraAuthKey: null,
    needAuth: { type: Boolean, default: true }
  },
  emits: ['change', 'init'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { defaultList: CommonUploaderFileListItem[], maxCount: string | number, useCrmUpload: boolean, capture?: string, disabled: boolean, cameraAuthKey?: string, needAuth: boolean };

expose({
  setFileList,
})



const { checkAuthorizationHandle, hasAuthorized } = useUserPermissionVerify(props.cameraAuthKey)
const uploadVm = ref(null)
const { vantUploadHandle, vantCrmUploadHandle } = useUploadImage()

const fileList: Ref<CommonUploaderFileListItem[]> = ref(props.defaultList)
const acceptValue = isAndrod && props.capture === 'camera' ? 'image/only_take_photo' : 'image/*'
const isReadOnly = computed(() => {
  return props.needAuth && props.cameraAuthKey && !hasAuthorized.value
})
function addFiles(files: File[]) {
  // 手动添加file文件
  fileList.value = fileList.value.concat(
    files.map((file) => ({
      status: '',
      file,
    }))
  )
  afterReadHandle()
}
console.log('hasAuthorized', hasAuthorized.value)
function changeHandle() {
  emits('change', fileList.value)
}
async function afterReadHandle() {
  const list = fileList.value.filter((item) => item.status === '')
  props.useCrmUpload ? await vantCrmUploadHandle(list) : await vantUploadHandle(list)
  changeHandle()
}

function deleteHandle() {
  changeHandle()
}

async function perrissionVerify() {
  if (!isReadOnly.value) {
    return
  }
  try {
    const useAgree = await checkAuthorizationHandle(props.cameraAuthKey)
    if (useAgree) {
      uploadVm.value?.chooseFile()
    }
  } catch (error) {
    console.log('error', error)
  }
}

function setFileList(list: CommonUploaderFileListItem[]) {
  fileList.value = list
}

function previewHandle(url: string) {
  ImagePreview([url])
}
emits('init', {
  addFiles,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_unref(Uploader), {
          key: 0,
          ref_key: "uploadVm",
          ref: uploadVm,
          class: "custom-wrap",
          afterRead: afterReadHandle,
          modelValue: fileList.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
          multiple: "",
          "upload-icon": "plus",
          "max-count": __props.maxCount,
          onDelete: deleteHandle,
          onClickUpload: perrissionVerify,
          accept: _unref(acceptValue),
          capture: __props.capture,
          readonly: _unref(isReadOnly)
        }, null, 8, ["modelValue", "max-count", "accept", "capture", "readonly"]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(fileList.value, (item) => {
          return (_openBlock(), _createBlock(_unref(Image), {
            class: "img-item",
            width: "80",
            height: "80",
            key: item.url,
            src: item.url,
            onClick: ($event: any) => (previewHandle(item.url))
          }, null, 8, ["src", "onClick"]))
        }), 128))
  ]))
}
}

})